// extracted by mini-css-extract-plugin
module.exports = {"container":"e_RF","icon":"e_SF"};